import data from './de.json';

const text = (key: string): string => {
    return (<Record<string, string>>data)[key] || key;
};

export default text;
